import { ReactNode, useContext, useMemo } from 'react'
import { Box, AppBar, Toolbar, Typography } from '@mui/material';
import { AppPaginator, NavItemDataProps, PaginatorProps } from '../../types';
import { URLAPP } from '../../config/contants.config';
import InputBaseSearch from '../inputs/InputBaseSearch';
import { DashboardContext } from '../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import logoHome from '../../assets/img/apidocs-logo.png'
import ContentMotion from './ContentMotion';
import PageMotion from './PageMotion';
import FooterPaginator from './FooterPaginator';
import ImageFile from '../artifacts/ImageFile';

interface AppDataWrapperProps {
    appendToolBar?: ReactNode
    children: ReactNode
    withFilter?: ReactNode,
    withSearch?: {
        search: string,
        onSearch: (keyword: string) => void
    }
    ResourceType?: string
    optionAppend?: ReactNode,
    replaceMenu?: NavItemDataProps,
    paginator?: AppPaginator
}

function AppDataWrapper({ appendToolBar, replaceMenu, children, withSearch, withFilter, paginator, optionAppend }: AppDataWrapperProps) {
    const dashboardContext = useContext(DashboardContext)
    const currentPage = useMemo(() => replaceMenu || dashboardContext?.navBar.menuSelected, [dashboardContext?.navBar.menuSelected, replaceMenu])

    return (
        <PageMotion>
            <AppBar position="static" color='inherit' elevation={1} style={{ boxShadow: 'none' }}>
                {currentPage?.breadcrumbs && <nav className='nav-router' aria-label="breadcrumb">
                    <ol className='breadcrumb'>
                        <li>
                            <Link to={URLAPP.start}>
                                <Typography component='span' sx={{ color: 'text.primary' }} variant='body2'>Inicio</Typography>
                            </Link>
                        </li>
                        {currentPage.breadcrumbs.map((b, idx) => <li key={b.path}>
                            {idx < currentPage.breadcrumbs.length - 1 ? <Link to={b.path}>
                                <Typography component='span' variant='body2' sx={{ color: 'text.primary' }}>{b.label}</Typography>
                            </Link> : <Typography component='span' variant='body2' sx={{ color: 'text.primary' }}>{b.label}</Typography>}
                        </li>)}
                    </ol>
                    <img src={logoHome} alt="logo-app" />
                </nav>}
                <Toolbar variant="dense" className='toolbar'>
                    {!withSearch && !withFilter && !optionAppend && <Box sx={{ flexGrow: 1 }} />}
                    <ContentMotion>
                        <Typography variant='h5' className='app-title'>
                            {currentPage?.avatar && <ImageFile
                                loading="lazy"
                                alt={'🎫'}
                                width={24}
                                height={24}
                                src={currentPage?.avatar}
                            />}
                            {currentPage?.icon && <FontAwesomeIcon icon={currentPage?.icon} />}  {currentPage?.label}
                        </Typography>
                    </ContentMotion>
                    <Box sx={{ flexGrow: 1 }} />
                    <div className='toolbar-append'>
                        {withFilter}
                        {withSearch && <InputBaseSearch expandable={true} search={withSearch.search} onSearch={withSearch.onSearch} />}
                        {optionAppend}
                    </div>
                </Toolbar>
                {appendToolBar && <Box sx={{ borderBottom: 1, borderColor: 'divider', display: "flex" }}>
                    {appendToolBar}
                </Box>}
            </AppBar>
            <ContentMotion style={{ marginTop: '1rem' }}>
                {children}
            </ContentMotion>
            {paginator && <FooterPaginator {...paginator} />}
        </PageMotion>
    )
}

export default AppDataWrapper